var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item)?_c('i',{staticClass:"fa fa-check-square-o",attrs:{"aria-hidden":"true"}}):_c('i',{staticClass:"fa fa-square-o",attrs:{"aria-hidden":"true"}})}
var staticRenderFns = []

export { render, staticRenderFns }